import type { CrudAction as CrudActionName, FieldAction } from '#layers/access/types/permissions/crud';
import type { AdminPolicyDocument, PolicyDocument } from '#layers/access/types/permissions/policy';
import { crudActions, fieldActions } from '#layers/access/types/permissions/crud';

export { allPolicyDocumentActions, policyFieldRuleActions, policyItemRuleAction } from '#layers/access/types/permissions/policy';

export function isFieldRulesAction(action: CrudActionName): action is FieldAction {
	return (fieldActions as readonly string[]).includes(action);
}

export function isItemRulesAction(action: CrudActionName): action is CrudActionName {
	return (crudActions as readonly string[]).includes(action);
}

export function isAdminPolicyDocument(policy: PolicyDocument): policy is AdminPolicyDocument {
	return policy.access === 'admin';
}
